/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SlackConnectionStatus,
    SlackConnectionStatusFromJSON,
    SlackConnectionStatusFromJSONTyped,
    SlackConnectionStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface SlackConnection
 */
export interface SlackConnection {
    /**
     * 
     * @type {number}
     * @memberof SlackConnection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SlackConnection
     */
    name: string;
    /**
     * 
     * @type {SlackConnectionStatus}
     * @memberof SlackConnection
     */
    status: SlackConnectionStatus;
}

export function SlackConnectionFromJSON(json: any): SlackConnection {
    return SlackConnectionFromJSONTyped(json, false);
}

export function SlackConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlackConnection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'status': SlackConnectionStatusFromJSON(json['status']),
    };
}

export function SlackConnectionToJSON(value?: SlackConnection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'status': SlackConnectionStatusToJSON(value.status),
    };
}


